package one.healthium.insights.domain.models

data class HintModel(
    val text: String?,
    val iconName: String?,
)
